import React from 'react';
import { DSIconSizes } from '@elliemae/ds-icon';
import { GripperVertical } from '@elliemae/ds-icons';

const DragControllerRow = ({
  className = 'drag-controller',
  color = ['neutral', '500'],
  icon: Icon = GripperVertical,
  size = DSIconSizes.M,
  ...rest
}) => (
  <div className={className} {...rest}>
    <Icon color={color} size={size} />
  </div>
);
export default DragControllerRow;
